const inputLogin = {
  username: 'nama pengguna',
  password: 'kata laluan',
};

export default inputLogin;
